import Axios from 'axios'
import store from '../store'
var qs = require('qs')

export default {
  getUrlBase() {
    const tenantId = store.getters['Client/clientId']
    return `api/v1/${tenantId}`
  },
  getAccessesFilters() {
    return Axios.get(`${this.getUrlBase()}/logs/filters`, {
      ignoreGlobalCatch: true,
    })
  },
  searchPersons(params) {
    return Axios.get(`${this.getUrlBase()}/persons/search`, {
      params,
      ignoreGlobalCatch: true,
    })
  },
  searchAccessLogs(params) {
    return Axios.get(`${this.getUrlBase()}/logs/search`, {
      params,
      ignoreGlobalCatch: true,
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
    })
  },
  exportAccessLogs(params) {
    let headers = {
      responseType: 'arraybuffer',
      ignoreGlobalCatch: true,
      params: params,
      'paramsSerializer': function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
    }
    return Axios.get(`${this.getUrlBase()}/logs/export`, headers)
  }
}
